import {Tabs, TabsContent, TabsList, TabsTrigger} from 'alm-react-components';
import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {AppContext} from '../../../context/AppProvider';
import {BillingInvoice} from './BillingInvoice';
import {NotificationSetting} from './NotificationSetting';
import {useLocation} from 'react-router-dom';
import {corporateKeys, TabConstants} from '../../../assets/constants/constants';
import notificationsTab from '../../../assets/images/svgicons/notifications-tab.svg';
import billingInvoices from '../../../assets/images/svgicons/billing-Invoices.svg';

const UserSettings = () => {
  const {state} = useContext(AppContext);
  const {t} = useTranslation();
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState('');

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);

  const setTabAction = (action: string) => {
    if (tabIndex !== action) setTabIndex(action);
  };
  useEffect(() => {
    if (location.pathname === '/user-settings/notification' ) {
      setTabIndex(TabConstants.notifications);
    }else if(state?.user && !state?.user?.sllCorporateAccountRoles?.includes(corporateKeys.LEARNER)) {
      setTabIndex(TabConstants.notifications);
    } else if(state?.user && state?.user?.sllCorporateAccountRoles?.includes(corporateKeys.LEARNER)) {
      setTabIndex(TabConstants.billing);
    }
  }, [state.user]);

  return (
    <section className="">
      <div className="w-[100%] mx-auto lg:px-32 lg:pt-14 pt-8 px-4">
        <div className="lg:flex lg:items-center lg:justify-between">
          <h1
            className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
            dangerouslySetInnerHTML={{
              __html: t("UserSettings.setting"),
            }}
          />
        </div>
      </div>
      <section className="">
        <div className="py-8 px-4 w-[100%] mx-auto xl:gap-0 lg:py-16 lg:px-32 flex flex-col lg:flex-row">
          <div className="mr-auto w-full">
            <div className="mt-1 text-sm leading-6 md:mt-0">
              <Tabs value={tabIndex} className="w-full bg-transparent">
                <TabsList className="w-full bg-transparent items-start justify-start border-b rounded-none h-auto p-0">
                { state?.user?.sllCorporateAccountRoles?.includes(corporateKeys.LEARNER)  && <TabsTrigger
                    onClick={() => setTabAction(TabConstants.billing)}
                    value={TabConstants.billing}
                    className={`px-0 pb-5 text-lg h-auto  rounded-none mx-[13px] ml-0 max-sm:text-sm max-sm:flex-col-reverse border-b-[4px] w-[max-content] border-transparent ${
                      tabIndex === TabConstants.billing
                        ? "border-b-[4px] dark:border-primary hover:dark:border-primary hover:dark:text-primary active:dark:border-primary"
                        : ""
                    }`}
                  >
                    <div className=" flex whitespace-break-spaces pt-2">
                      {t("UserSettings.bill")}
                    </div>
                    <div className="">
                      <img
                        src={billingInvoices}
                        alt=""
                        aria-label="back"
                        className=" h-[17px] logo ml-2 mt-2"
                      />
                    </div>
                  </TabsTrigger>}
                  <TabsTrigger
                    onClick={() => setTabAction(TabConstants.notifications)}
                    value={TabConstants.notifications}
                    className={`px-0 pb-5 text-lg h-auto rounded-none mx-[13px] max-sm:text-sm max-sm:flex-col-reverse border-b-[4px] w-[max-content]  border-transparent ${
                      tabIndex === TabConstants.notifications
                        ? "border-b-[4px] dark:border-primary hover:dark:border-primary hover:dark:text-primary active:dark:border-primary"
                        : ""
                    }`}
                  >
                    <div className=" flex whitespace-break-spaces pt-2">
                      {t("UserSettings.notifications")}
                    </div>
                    <div className="">
                      <img
                        src={notificationsTab}
                        alt=""
                        aria-label="back"
                        className=" h-[17px] logo ml-2 mt-2"
                      />
                    </div>
                  </TabsTrigger>
                </TabsList>
                {state?.user?.sllCorporateAccountRoles?.includes(corporateKeys.LEARNER)  &&<TabsContent
                  value={TabConstants.billing}
                  className="w-full py-5"
                >
                  <BillingInvoice />
                </TabsContent>}
                <TabsContent
                  value={TabConstants.notifications}
                  className="w-full py-5"
                >
                  <NotificationSetting />
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
      <div className="gap-8 py-8 px-4 w-[100%] mx-auto md:px-32 md:pt-10 md:grid sm:px-0"></div>
    </section>
  );
};
export default UserSettings;
